export const data = {
  title: 'Featured Transport',
  data: [
    { name:'Kathmandu - Ramechhap', startingPrice: { currency: 'USD', amount: 30 }, url: '/transportation/list?from_location=Kathmandu&pax=1&to_location=Ramechhap&trip_type=R', imageUrl: 'https://s3.amazonaws.com/honeyguide/assets/hiace.jpg' },
    { name:'Kathmandu - Pokhara', startingPrice: { currency: 'USD', amount: 14 }, url: '/transportation/list?from_location=Kathmandu&pax=1&to_location=Pokhara&trip_type=R', imageUrl: 'https://s3.amazonaws.com/honeyguide/assets/tourist-bus.jpg' },
    { name:'Pokhara - Jomsom', startingPrice: { currency: 'USD', amount: 24 }, url: '/transportation/list?from_location=Pokhara&pax=1&to_location=Jomsom&trip_type=R', imageUrl: 'https://s3.amazonaws.com/honeyguide/assets/jeep.jpg' },
    { name:'Kathmandu - Jomsom', startingPrice: { currency: 'USD', amount: 28 }, url: '/transportation/list?from_location=Kathmandu&pax=1&to_location=Jomsom&trip_type=R', imageUrl: 'https://s3.amazonaws.com/honeyguide/assets/ktm-jomsom-bus-and-pokhara-jomsom-bus.jpg' }
  ],
};

export default data;



// WEBPACK FOOTER //
// ./src/components/FeaturedTransportSlider/data.js